import { appConfig } from '../config/appConfig';

const TemplatedMsgBackendProxy = (function (endpointUrl) {
  const confEndpointUrl = endpointUrl;

  return {
    getByBotAccountId(botAccountId, contactId) {
      return fetch(
        `${confEndpointUrl}/services/template/${botAccountId}/${contactId}`,
        {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          },
          credentials: 'include',
        }
      ).catch(error => {
        // HTTP 403: Forbidden means that session expired or was invalidated somehow
        if (error && error.response && error.response.status === 403) {
          console.debug('Forbidden, going back to Login...', error);
          window.location.replace('/login');
        } else {
          console.debug('Error getting general properties', error);
        }
      });
    },
  };
})(appConfig.webServicesBaseUri);

export default TemplatedMsgBackendProxy;
